module.exports = __webpack_public_path__ + "static/media/1POLICY32.6b521086.jpg";